import { render, staticRenderFns } from "./WeightSelector.vue?vue&type=template&id=85f583f2&"
import script from "./WeightSelector.vue?vue&type=script&lang=js&"
export * from "./WeightSelector.vue?vue&type=script&lang=js&"
import style0 from "./WeightSelector.vue?vue&type=style&index=0&id=85f583f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports